// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Map from "rescript/lib/es6/belt_Map.js";
import * as Belt_Set from "rescript/lib/es6/belt_Set.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Localforage from "localforage";
import * as Core__Promise from "@rescript/core/src/Core__Promise.res.js";
import * as Hooks$Coronate from "./Hooks.res.js";
import * as Data_Id$Coronate from "./Data/Data_Id.res.js";
import * as DemoData$Coronate from "./testdata/DemoData.res.js";
import * as Data_Auth$Coronate from "./Data/Data_Auth.res.js";
import * as Data_Config$Coronate from "./Data/Data_Config.res.js";
import * as Data_Player$Coronate from "./Data/Data_Player.res.js";
import * as LocalForage_Id$Coronate from "./Externals/LocalForage_Id.res.js";
import * as Data_Tournament$Coronate from "./Data/Data_Tournament.res.js";
import * as LocalForage_Map$Coronate from "./Externals/LocalForage_Map.res.js";
import * as LocalForage_Record$Coronate from "./Externals/LocalForage_Record.res.js";

var Config = LocalForage_Id$Coronate.MakeEncodable({
      encode: Data_Config$Coronate.encode,
      decode: Data_Config$Coronate.decode
    });

var Player = LocalForage_Id$Coronate.MakeEncodable({
      encode: Data_Player$Coronate.encode,
      decode: Data_Player$Coronate.decode
    });

var Tournament = LocalForage_Id$Coronate.MakeEncodable({
      encode: Data_Tournament$Coronate.encode,
      decode: Data_Tournament$Coronate.decode
    });

var Auth = LocalForage_Id$Coronate.MakeEncodable(Data_Auth$Coronate);

var configDb = LocalForage_Record$Coronate.make({
      name: "Coronate",
      storeName: "Options"
    }, Config);

var authDb = LocalForage_Record$Coronate.make({
      name: "Coronate",
      storeName: "Auth"
    }, Auth);

var players = LocalForage_Map$Coronate.make({
      name: "Coronate",
      storeName: "Players"
    }, Player);

var tournaments = LocalForage_Map$Coronate.make({
      name: "Coronate",
      storeName: "Tournaments"
    }, Tournament);

function loadDemoDB(param) {
  ((document.body.style.cursor = "wait"));
  Core__Promise.$$catch(Promise.all([
                LocalForage_Record$Coronate.set(configDb, DemoData$Coronate.config),
                LocalForage_Map$Coronate.setItems(players, Data_Id$Coronate.$$Map.toStringArray(DemoData$Coronate.players)),
                LocalForage_Map$Coronate.setItems(tournaments, Data_Id$Coronate.$$Map.toStringArray(DemoData$Coronate.tournaments))
              ]).then(function (param) {
              window.alert("Demo data loaded!");
            }), (function (param) {
            ((document.body.style.cursor = "auto"));
            window.alert("Couldn't load demo data.");
            return Promise.resolve();
          })).finally(function () {
        ((document.body.style.cursor = "auto"));
      });
}

function genericDbReducer(state, action) {
  switch (action.TAG) {
    case "Del" :
        return Belt_Map.remove(state, action._0);
    case "Set" :
        return Belt_Map.set(state, action._0, action._1);
    case "SetAll" :
        return action._0;
    
  }
}

function useAllDb(store) {
  var match = React.useReducer(genericDbReducer, Belt_Map.make(Data_Id$Coronate.id));
  var dispatch = match[1];
  var items = match[0];
  var loaded = Hooks$Coronate.useBool(false);
  Hooks$Coronate.useLoadingCursorUntil(loaded.state);
  React.useEffect((function () {
          var didCancel = {
            contents: false
          };
          Core__Promise.$$catch(LocalForage_Map$Coronate.getAllItems(store).then(function (results) {
                    if (!didCancel.contents) {
                      dispatch({
                            TAG: "SetAll",
                            _0: Data_Id$Coronate.$$Map.fromStringArray(results)
                          });
                      return loaded.setTrue();
                    }
                    
                  }), (function (error) {
                  if (!didCancel.contents) {
                    console.error(error);
                    Localforage.clear();
                    loaded.setTrue();
                  }
                  return Promise.resolve();
                }));
          return (function () {
                    didCancel.contents = true;
                  });
        }), []);
  React.useEffect((function () {
          if (loaded.state) {
            LocalForage_Map$Coronate.setItems(store, Data_Id$Coronate.$$Map.toStringArray(items)).then(function () {
                    return LocalForage_Map$Coronate.getKeys(store);
                  }).then(function (keys) {
                  var deleted = Belt_Array.keep(keys, (function (x) {
                          return !Belt_Map.has(items, Data_Id$Coronate.fromString(x));
                        }));
                  return LocalForage_Map$Coronate.removeItems(store, deleted);
                });
          }
          
        }), [
        items,
        loaded.state
      ]);
  return {
          items: items,
          dispatch: dispatch,
          loaded: loaded.state
        };
}

function useAllPlayers() {
  return useAllDb(players);
}

function useAllTournaments() {
  return useAllDb(tournaments);
}

function configReducer(state, action) {
  switch (action.TAG) {
    case "AddAvoidPair" :
        return {
                avoidPairs: Belt_Set.add(state.avoidPairs, action._0),
                byeValue: state.byeValue,
                lastBackup: state.lastBackup,
                whiteAlias: state.whiteAlias,
                blackAlias: state.blackAlias
              };
    case "DelAvoidPair" :
        return {
                avoidPairs: Belt_Set.remove(state.avoidPairs, action._0),
                byeValue: state.byeValue,
                lastBackup: state.lastBackup,
                whiteAlias: state.whiteAlias,
                blackAlias: state.blackAlias
              };
    case "DelAvoidSingle" :
        var id = action._0;
        return {
                avoidPairs: Belt_Set.keep(state.avoidPairs, (function (pair) {
                        return !Data_Id$Coronate.Pair.has(pair, id);
                      })),
                byeValue: state.byeValue,
                lastBackup: state.lastBackup,
                whiteAlias: state.whiteAlias,
                blackAlias: state.blackAlias
              };
    case "SetAvoidPairs" :
        return {
                avoidPairs: action._0,
                byeValue: state.byeValue,
                lastBackup: state.lastBackup,
                whiteAlias: state.whiteAlias,
                blackAlias: state.blackAlias
              };
    case "SetByeValue" :
        return {
                avoidPairs: state.avoidPairs,
                byeValue: action._0,
                lastBackup: state.lastBackup,
                whiteAlias: state.whiteAlias,
                blackAlias: state.blackAlias
              };
    case "SetState" :
        return action._0;
    case "SetLastBackup" :
        return {
                avoidPairs: state.avoidPairs,
                byeValue: state.byeValue,
                lastBackup: action._0,
                whiteAlias: state.whiteAlias,
                blackAlias: state.blackAlias
              };
    case "SetWhiteAlias" :
        return {
                avoidPairs: state.avoidPairs,
                byeValue: state.byeValue,
                lastBackup: state.lastBackup,
                whiteAlias: Data_Config$Coronate.alias(action._0),
                blackAlias: state.blackAlias
              };
    case "SetBlackAlias" :
        return {
                avoidPairs: state.avoidPairs,
                byeValue: state.byeValue,
                lastBackup: state.lastBackup,
                whiteAlias: state.whiteAlias,
                blackAlias: Data_Config$Coronate.alias(action._0)
              };
    
  }
}

function useConfig() {
  var match = React.useReducer(configReducer, Data_Config$Coronate.default);
  var dispatch = match[1];
  var config = match[0];
  var loaded = Hooks$Coronate.useBool(false);
  React.useEffect((function () {
          var didCancel = {
            contents: false
          };
          Core__Promise.$$catch(LocalForage_Record$Coronate.get(configDb).then(function (values) {
                    if (!didCancel.contents) {
                      dispatch({
                            TAG: "SetState",
                            _0: values
                          });
                      return loaded.setTrue();
                    }
                    
                  }), (function (error) {
                  if (!didCancel.contents) {
                    console.error(error);
                    Localforage.clear();
                    dispatch({
                          TAG: "SetState",
                          _0: Data_Config$Coronate.default
                        });
                    loaded.setTrue();
                  }
                  return Promise.resolve();
                }));
          return (function () {
                    didCancel.contents = true;
                  });
        }), []);
  React.useEffect((function () {
          if (loaded.state) {
            LocalForage_Record$Coronate.set(configDb, config);
          }
          
        }), [
        config,
        loaded.state
      ]);
  return [
          config,
          dispatch
        ];
}

function authReducer(state, action) {
  if (typeof action !== "object") {
    if (action === "RemoveGistId") {
      return {
              github_token: state.github_token,
              github_gist_id: ""
            };
    } else {
      return Data_Auth$Coronate.default;
    }
  }
  switch (action.TAG) {
    case "SetGitHubToken" :
        return {
                github_token: action._0,
                github_gist_id: state.github_gist_id
              };
    case "SetGistId" :
        return {
                github_token: state.github_token,
                github_gist_id: action._0
              };
    case "SetState" :
        return action._0;
    
  }
}

function useAuth() {
  var match = React.useReducer(authReducer, Data_Auth$Coronate.default);
  var dispatch = match[1];
  var auth = match[0];
  var loaded = Hooks$Coronate.useBool(false);
  React.useEffect((function () {
          var didCancel = {
            contents: false
          };
          Core__Promise.$$catch(LocalForage_Record$Coronate.get(authDb).then(function (values) {
                    if (!didCancel.contents) {
                      dispatch({
                            TAG: "SetState",
                            _0: values
                          });
                      return loaded.setTrue();
                    }
                    
                  }), (function (param) {
                  if (!didCancel.contents) {
                    Localforage.clear();
                    dispatch({
                          TAG: "SetState",
                          _0: Data_Auth$Coronate.default
                        });
                    loaded.setTrue();
                  }
                  return Promise.resolve();
                }));
          return (function () {
                    didCancel.contents = true;
                  });
        }), []);
  React.useEffect((function () {
          if (loaded.state) {
            LocalForage_Record$Coronate.set(authDb, auth);
          }
          
        }), [
        auth,
        loaded.state
      ]);
  return [
          auth,
          dispatch
        ];
}

export {
  loadDemoDB ,
  Config ,
  Tournament ,
  Player ,
  tournaments ,
  useAllPlayers ,
  useAllTournaments ,
  useConfig ,
  useAuth ,
}
/* Config Not a pure module */
